/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import { React } from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import PublishIcon from "@material-ui/icons/Publish";
import Menu from "@material-ui/core/Menu";
import '../../css/Common.css'

/**
 * A file containing commonly-used button components
 */
export function CloseButton(props) {

    return (
        <Button
            variant="outlined"
            color="secondary"
            className='common-button'
            onClick={props.handleClose}
        >
            Close
        </Button>
    );
}

export function SaveButton(props) {

    return (
        <Button
            variant="contained"
            color="primary"
            className='common-button'
            onClick={props.clickHandler}
            startIcon={<PublishIcon />}
        >
            {props.saveType}
        </Button>
    );
}

export const QuestionIndexSelection = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));
